import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const AuthRoute = ({component: Component, loggedIn, ...rest}) => {
	return (
		<Route {...rest} render={props => (
			loggedIn ?
				<Component {...props} />
			:
				<Redirect to="/login" />
		)} />
	);
};

export default AuthRoute;